import { ANIMATE_DELAY, ANIMATED_STYLE } from "src/libs/interfaces/animated";
import { __, getID } from "src/libs/utilities";
import { ALIGN, LANDING_TYPE_CONTENT } from "../interfaces";
export default function shedules(): any[] {
    return [
        {
            "id": getID( LANDING_TYPE_CONTENT.SHEDULE_CARDS ),
            "vertical_align": ALIGN.FULL,
            "animated": ANIMATED_STYLE.FADE_IN_UP,
            "animated_delay": ANIMATE_DELAY.WATERFALL,
            "type": LANDING_TYPE_CONTENT.SHEDULE_CARDS,
            "columns": 2, 
            "design_type": 1,
            "order": [
                "thumbnail",
                "order",
                "title",
                "description",
                "time",
                "buttons"
            ], 
            "cards": [
                {
                "id": getID("card"),
                "thumbnail": {
                    "data": "https://i.pinimg.com/1200x/a4/a7/54/a4a75463da3c24da4292e47866446ef1.jpg"
                },
                "order": {},
                "title": { "data": "Начало всего" },
                "description": {
                    "data": "Трансляция пока будет продолжаться, поэтому можно и дальше наблюдать за гнездовьем солнечных орлов. Ведь даже без хозяев на гнезде бывает интересно."
                },
                "time": {
                    "start_time": (new Date()).getTime() / 1000,
                    "finish_time": (new Date()).getTime() / 1000 + 1000000,
                    "intent": "success"
                },
                "person": {
                    "user": {
                    "id": getID("user"),
                    "display_name": "Потап Потапыч Левиофанъ",
                    "avatar": "https://i.pinimg.com/736x/8f/3d/dc/8f3ddcf4d9ad1327f77dc802ec712b1d.jpg",
                    "description": "Умная каракатица. Завуч"
                    }
                },
                "statistic_line": { "data": [45, 12] },
                "buttons": {
                    "buttons": [
                    {
                        "label": "Далее",
                        "url": "https://ru.pinterest.com/pin/3518505954759098/",
                        "design_type": "outline_bw"
                    }
                    ]
                }
                },
                {
                "id": getID("card"),
                "thumbnail": {
                    "data": "https://i.pinimg.com/1200x/e1/72/81/e172813320ada52e4d658dfc8da1eb85.jpg"
                },
                "order": {},
                "title": { "data": "Продолжение всего" },
                "description": {
                    "data": "Молодой человек ушёл от семьи и уехал за духовными исканиями в наш Владимир, где занимается, собственно, духовными исканиями, пьёт, пишет книжку и работает экскурсоводом."
                },
                "time": {
                    "start_time": (new Date()).getTime() / 1000,
                    "finish_time": (new Date()).getTime() / 1000 + 1000000,
                },
                "person": {
                    "user": {
                    "id": getID("user"),
                    "display_name": "Бри Ларссон",
                    "avatar": "https://i.pinimg.com/1200x/20/2d/9f/202d9f6b051b6bd4f917e5a3aa6960cd.jpg",
                    "description": "Учитель москваведения. Профессор ксенологии королевсого университета Мбабане."
                    }
                },
                "statistic_line": { "data": [32, 85] },
                "buttons": {
                    "buttons": [
                    {
                        "label": "Далее",
                        "url": "https://ru.pinterest.com/pin/27654985208103866/",
                        "design_type": "outline_bw"
                    }
                    ]
                }
                },
                {
                "id": getID("card"),
                "thumbnail": {
                    "data": "https://i.pinimg.com/236x/3d/82/b0/3d82b0e23b322bffdafae5cbf892086c.jpg"
                },
                "order": {},
                "title": { "data": "Окончание всего" },
                "description": {
                    "data": "<p>Встречи с чудовищами - редкий для советской фантастики тип историй. Его развитию мешала приставка «научный» в жанровом определении. Однако все равно эти истории время от времени прорывались на страницы журналов."
                },
                "time": {
                    "start_time": (new Date()).getTime() / 1000,
                    "finish_time": (new Date()).getTime() / 1000 + 1000000,
                },
                "person": {
                    "user": {
                    "id": getID("user"),
                    "display_name": "Матвей Епифанович Кыщ",
                    "avatar": "https://i.pinimg.com/1200x/7a/2e/81/7a2e8188dafcc2eeb1f3ed10e0804eb4.jpg",
                    "description": "Учитель пения. Контртенор."
                    }
                },
                "statistic_line": { "data": [90, 43] },
                "buttons": {
                    "buttons": [
                    {
                        "label": "Далее",
                        "url": "https://ru.pinterest.com/pin/6825836929876003/",
                        "design_type": "outline_bw"
                    }
                    ]
                }
                },
                {
                "id": getID("card"),
                "thumbnail": {
                    "data": "https://i.pinimg.com/736x/1b/d1/84/1bd184523595b08bb17055f117930f07.jpg"
                },
                "order": {},
                "title": { "data": "Подведение итогов всего" },
                "description": {
                    "data": "<p>Суперхитом 1956 года среди журнальных фантастических публикаций стала повесть Эдмонда Гамильтона «Сокровище Громовой Луны». Советской фантастике очень не хватало авантюризма, приключенческих сюжетов."
                },
                "time": {
                    "start_time": (new Date()).getTime() / 1000,
                    "finish_time": (new Date()).getTime() / 1000 + 1000000,
                },
                "person": {
                    "user": {
                    "id": getID("user"),
                    "first_name": "Паулина",
                    "last_name": "Шикардос",
                    "description": "Заместитель главного директора по всему",
                    "avatar": "https://i.pinimg.com/736x/9a/db/b1/9adbb1d530a9b7d47ebf8236a4234d26.jpg"
                    }
                },
                "statistic_line": { "data": [40, 73] },
                "buttons": {
                    "buttons": [
                        {
                            "label": "Далее",
                            "url": "https://ru.pinterest.com/pin/11822017767668190/",
                            "design_type": "outline_bw"
                        }
                    ]
                }
                }
            ],
            "style": {
                "backgroundColor": "var(--force-plain-color)",
                "border": "1px solid var(--force-mini-contast-color)"
            },
            defaultTitle: "Шахматные горизонтальные карточки с картинкой и бабблом"
        },
        {
            "type": LANDING_TYPE_CONTENT.SHEDULE_CARDS,
            "id": getID(LANDING_TYPE_CONTENT.SHEDULE_CARDS),
            "vertical_align": ALIGN.FULL,
            "animated": ANIMATED_STYLE.FADE_IN_UP,
            "animated_delay": ANIMATE_DELAY.WATERFALL,
            "columns": 3,
            "order": [
                "thumbnail",
                "order",
                "time",
                "title",
                "description",
                "statistic_line",
                "person",
                "checkbox",
                "links"
            ],
            "design_type": 2,
            "cards": [
                {
                "id": getID("card"),
                "thumbnail": { 
                    "data": "https://i.pinimg.com/1200x/6f/f1/f6/6ff1f64269e43211ecaa43ae6b6eb3ad.jpg"
                },
                "order": {},
                "title": { "data": "Начало всего" },
                "description": {
                    "data": "Трансляция пока будет продолжаться, поэтому можно и дальше наблюдать за гнездовьем солнечных орлов. Ведь даже без хозяев на гнезде бывает интересно."
                },
                "time": { 
                    "start_time": (new Date()).getTime() / 1000,
                    "finish_time": (new Date()).getTime() / 1000 + 1000000,
                },
                "person": { 
                    "user": {
                        "id": getID("user"),
                        "display_name": "Потап Потапыч Левиофанъ",
                        "avatar": "https://i.pinimg.com/736x/8f/3d/dc/8f3ddcf4d9ad1327f77dc802ec712b1d.jpg",
                        "description": "Умная каракатица. Завуч" 
                    }
                },
                "statistic_line": { "data": [45, 12] }
                },
                {
                "id": getID("card"),
                "thumbnail": { 
                    "data": "https://i.pinimg.com/736x/52/a8/18/52a818271bd6d12492e77ba3e86de69a.jpg"
                },
                "order": {},
                "title": { "data": "Продолжение всего" },
                "description": {
                    "data": "Молодой человек ушёл от семьи и уехал за духовными исканиями в наш Владимир, где занимается, собственно, духовными исканиями, пьёт, пишет книжку и работает экскурсоводом."
                },
                "time": { 
                    "start_time": (new Date()).getTime(),
                    "finish_time": (new Date()).getTime() + 100000, 
                },
                "person": { 
                    "user": {
                        "id": "11",
                        "display_name": "Бри Ларссон",
                        "avatar": "https://i.pinimg.com/1200x/20/2d/9f/202d9f6b051b6bd4f917e5a3aa6960cd.jpg",
                        "description": "Учитель москваведения. Профессор ксенологии королевсого университета Мбабане."
                    } 
                },
                "statistic_line": { "data": [32, 85] }
                },
                {
                "id": getID("card"),
                "thumbnail": { 
                    "data": "https://i.pinimg.com/736x/7b/72/dc/7b72dcc355c4c4c1cee15af6c5c5e2f9.jpg"
                },
                "order": {},
                "title": { "data": "Окончание всего" },
                "description": {
                    "data": "<p>Встречи с чудовищами - редкий для советской фантастики тип историй. Его развитию мешала приставка «научный» в жанровом определении. "
                },
                "time": { 
                    "start_time": (new Date()).getTime() / 1000,
                    "finish_time": (new Date()).getTime() / 1000 + 1000000,
                },
                "person": { 
                    "user": {
                        "id": getID("user"),
                        "display_name": "Матвей Епифанович Кыщ",
                        "avatar": "https://i.pinimg.com/1200x/7a/2e/81/7a2e8188dafcc2eeb1f3ed10e0804eb4.jpg",
                        "description": "Учитель пения. Контртенор." 
                    }
                },
                "statistic_line": { "data": [90, 43] }
                }
            ],
            "style": {
                "backgroundColor": "var(--force-plain-secondary-opacity-color)",
                "border": "1px solid var(--force-mini-contast-color)"
            },
            defaultTitle: "Просто карточки"
        },
        {
            "type": LANDING_TYPE_CONTENT.SHEDULE_CARDS,
            "id": getID(LANDING_TYPE_CONTENT.SHEDULE_CARDS),
            "vertical_align": ALIGN.FULL,
            "animated": ANIMATED_STYLE.FADE_IN_UP,
            "animated_delay": ANIMATE_DELAY.WATERFALL,
            "order": [
                "thumbnail",
                "order",
                "time",
                "title",
                "description",
                "statistic_line",
                "person",
                "checkbox",
                "buttons"
            ], 
            "design_type": 3,
            "cards": [
                {
                    "id": getID( "card" ),
                    "thumbnail": {
                        "data": "https://i.pinimg.com/1200x/47/3b/32/473b32ecd87e278b3d5633cff8f38828.jpg"
                    },
                    "order": {},
                    "title": { "data": "Начало всего" },
                    "description": {
                        "data": "Трансляция пока будет продолжаться, поэтому можно и дальше наблюдать за гнездовьем солнечных орлов. Ведь даже без хозяев на гнезде бывает интересно. Например, в прошлом году благодаря онлайн-камере удалось впервые для национального парка «Сенгилеевские горы» обнаружить редкую в нашей области птичку — хохлатую синицу. В осенне-зимний период частыми гостями на гнезде бывают орланы-белохвосты."
                    },
                    "time": { 
                        "start_time": (new Date()).getTime() / 1000,
                        "finish_time": (new Date()).getTime() / 1000 + 1000000,
                    },
                    "person": {
                        "user": {
                            "id": getID("user"),
                            "display_name": "Потап Потапыч Левиофанъ",
                            "avatar": "https://i.pinimg.com/1200x/69/9a/fe/699afe7fb23e3a4d3dafe996e8254e54.jpg",
                            "description": "Умная каракатица. Завуч" 
                        }
                    },
                    "statistic_line": { "data": [45, 12] },
                    "buttons": { 
                        buttons : [
                            {
                                label: __("More"),
                                url: "https://ya.ru", 
                            }
                        ]     
                    },
                },
                {
                    "id": getID( "card" ),
                    "thumbnail": { 
                        "data": "https://i.pinimg.com/736x/34/ba/54/34ba5450bd99fcd160fd15f8f157329a.jpg"
                    },
                    "order": {},
                    "title": { "data": "Продолжение всего" },
                    "description": {
                        "data": "Молодой человек ушёл от семьи и уехал за духовными исканиями в наш Владимир, где занимается, собственно, духовными исканиями, пьёт, пишет книжку и работает экскурсоводом. К нему приезжает тесть с сыном, который скучает по отцу. У тестя целых два коварных плана: либо вернуть блудного в семью, либо, если не согласится, дискредитировать перед сыном. Но ничего этого не получается. Они заходят в Успенский собор и потом ночуют у Покрова на Нерли, сын впечатлён и обещает вернуться, когда подрастёт."
                    },
                    "time": { 
                        "start_time": (new Date()).getTime() / 1000,
                        "finish_time": (new Date()).getTime() / 1000 + 1000000,
                    },
                    "person": { 
                        "user": {
                            "id": getID("user"),
                            "display_name": "Бри Ларссон",
                            "avatar": "https://i.pinimg.com/1200x/20/2d/9f/202d9f6b051b6bd4f917e5a3aa6960cd.jpg",
                            "description": "Учитель москваведения. Профессор ксенологии королевсого университета Мбабане." 
                        }
                    },
                    "statistic_line": { "data": [32, 85] },
                    "buttons": { 
                        buttons : [
                            {
                                label: __("More"),
                                url: "https://ya.ru", 
                            }
                        ]     
                    },
                },
                {
                    "id": getID( "card" ),
                    "thumbnail": { 
                        "data": "https://i.pinimg.com/736x/18/49/01/18490141a64d79f09f1b7e8c54c2ae2a.jpg"
                    },
                    "order": {},
                    "title": { "data": "Окончание всего" },
                    "description": {
                        "data": "<p>Встречи с чудовищами - редкий для советской фантастики тип историй. Его развитию мешала приставка «научный» в жанровом определении. Однако все равно эти истории время от времени прорывались на страницы журналов. То про растения, потребляющих путешественников, то про гигантских насекомых, нападающих на аэропланы.<p>В 1936 году на страницах «Вокруг света» таких историй случилось - небывалое дело! -сразу две. Некто, укрывшийся под псевдонимом А. Фористер сначала рассказал о гнезде гигантских ос (Дьявол Белой горы), а потом о гигантской стрекозе, пьющей кровь у геологов (Меганейра). Для первой истории иллюстрации сделал Неимоверный Кочергин, а историю про стрекозу-вампира проиллюстрировал Александр Медельский."
                    },
                    "time": { 
                        "start_time": (new Date()).getTime() / 1000,
                        "finish_time": (new Date()).getTime() / 1000 + 1000000,
                    },
                    "person": {                         
                        "user": {
                            "id": getID("user"),
                            "display_name": "Матвей Епифанович Кыщ",
                            "avatar": "https://i.pinimg.com/1200x/7a/2e/81/7a2e8188dafcc2eeb1f3ed10e0804eb4.jpg",
                            "description": "Учитель пения. Контртенор."  
                        }
                    },
                    "statistic_line": { "data": [90, 43] },
                    "buttons": { 
                        buttons : [
                            {
                                label: __("More"),
                                url: "https://ya.ru", 
                            }
                        ]     
                    },
                }
            ],
            "style": {
                "backgroundColor": "var(--force-plain-secondary-opacity-color)",
                "border": "1px solid var(--force-mini-contast-color)"
            },
            defaultTitle: "Архивные карточки"
        }
    ]
}